/**
 * @file Registre generique cle -> module (comportements d'armes, modes, IA, sources de bonus). Enregistrement explicite, lookup strict.
 */

export class Registry<K extends string, V> {
  private readonly map = new Map<K, V>();

  constructor(readonly kind: string) {}

  register(key: K, value: V): this {
    if (this.map.has(key)) throw new Error(`${this.kind}: duplicate registration "${key}"`);
    this.map.set(key, value);
    return this;
  }

  get(key: K): V {
    const v = this.map.get(key);
    if (v === undefined) throw new Error(`${this.kind}: "${key}" is not registered`);
    return v;
  }

  tryGet(key: K): V | undefined {
    return this.map.get(key);
  }

  has(key: K): boolean {
    return this.map.has(key);
  }

  keys(): K[] {
    return [...this.map.keys()];
  }

  values(): V[] {
    return [...this.map.values()];
  }
}
